import routerOptions0 from "/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/data/soft/jenkins/workspace/olamet-client-Pipeline-deploy/app/router.options.ts";
const configRouterOptions = {
  hashMode: true,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}